"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _layout = require("../layout");

var _screenReaderOnly = require("../screen-reader-only");

var _text = require("../text");

var _utils = require("../utils");

var _ProgressBarSegment = _interopRequireDefault(require("./ProgressBarSegment"));

var _ProgressBarThreshold = _interopRequireDefault(require("./ProgressBarThreshold"));

var _aria = require("./aria");

var _constants = require("./constants");

var _helperComponents = require("./helperComponents");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

var _excluded = ["progressSummary", "status", "progress", "threshold", "thresholdStatus", "aria-live", "aria-label", "dataTestId", "shouldShowProgressSummary", "isProgressAnnounceable"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ProgressBar = function ProgressBar(_ref) {
  var progressSummary = _ref.progressSummary,
      status = _ref.status,
      progress = _ref.progress,
      threshold = _ref.threshold,
      thresholdStatus = _ref.thresholdStatus,
      ariaLive = _ref['aria-live'],
      ariaLabel = _ref['aria-label'],
      dataTestId = _ref.dataTestId,
      shouldShowProgressSummary = _ref.shouldShowProgressSummary,
      _ref$isProgressAnnoun = _ref.isProgressAnnounceable,
      isProgressAnnounceable = _ref$isProgressAnnoun === void 0 ? _constants.defaultIsProgressAnnounceable : _ref$isProgressAnnoun,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      liveMessage = _useState2[0],
      setLiveMessage = _useState2[1];

  var shouldAnnounce = isProgressAnnounceable(progress);
  (0, _react.useEffect)(function () {
    if (ariaLive !== 'off' && shouldAnnounce) {
      setLiveMessage("".concat((0, _aria.getAriaSummary)(progressSummary, status, threshold)).concat(ariaLabel ? ", ".concat(ariaLabel) : '', ", ").concat((0, _constants.formatProgress)(progress), "%, progress indicator."));
    }
  }, [progress, progressSummary, status, threshold, liveMessage, ariaLabel, ariaLive, shouldAnnounce]);
  var summary = (0, _aria.getAriaSummary)(progressSummary, status, threshold);
  var segmentProps = {
    status: status,
    progress: progress,
    threshold: threshold
  };
  var hasThreshold = !!threshold && threshold < 1;
  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilProgressBar',
    dataTestId: dataTestId
  });
  return (0, _core.jsx)(_layout.Col, {
    gridGap: 'S200',
    width: "100%"
  }, shouldShowProgressSummary && (0, _core.jsx)(_text.Label, {
    "aria-hidden": true
  }, "".concat(progress * 100, "% "), summary), (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, null, (0, _core.jsx)("div", {
    role: "status",
    "aria-live": shouldAnnounce ? ariaLive : 'off',
    "aria-atomic": "true"
  }, liveMessage)), (0, _core.jsx)(_helperComponents.ProgressBarOuter, {
    "aria-live": shouldAnnounce ? ariaLive : 'off'
  }, (0, _core.jsx)(_helperComponents.ProgressBarHidden, (0, _extends2.default)({
    "aria-label": ariaLabel ? "".concat(ariaLabel, ", ").concat(summary) : summary,
    value: progress
  }, forwardedProps, dataTestProps)), (0, _core.jsx)(_layout.Row, {
    gridGap: hasThreshold ? _constants.PROGRESS_BAR_THRESHOLD_WIDTH : undefined,
    alignItems: "center",
    minWidth: _constants.PROGRESS_BAR_MIN_WIDTH,
    width: "100%",
    "aria-hidden": true
  }, (0, _core.jsx)(_ProgressBarSegment.default, segmentProps), hasThreshold && (0, _core.jsx)(_ProgressBarThreshold.default, {
    status: thresholdStatus
  }), (0, _core.jsx)(_ProgressBarSegment.default, (0, _extends2.default)({
    isTrailing: true
  }, segmentProps)))));
};

ProgressBar.displayName = 'ProgressBar';
ProgressBar.defaultProps = {
  'aria-live': 'off',
  isProgressAnnounceable: _constants.defaultIsProgressAnnounceable
};
var ProgressBarWithDocs = (0, _stencilReactDesc.describe)(ProgressBar).description('Provides a visual representation of progress.');
ProgressBarWithDocs.propTypes = {
  status: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ProgressBarStatus)).description('Determines the color of the progress bar.'),
  progress: _stencilReactDesc.PropTypes.number.isRequired.description('Amount of the progress bar to fill as a number between 0 and 1.'),
  threshold: _stencilReactDesc.PropTypes.number.description('Display a threshold marker at the given point in the progress bar, as a value between 0 and 1.'),
  thresholdStatus: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ProgressBarStatus)).description('Determines the color of the threshold marker.'),
  progressSummary: _stencilReactDesc.PropTypes.string.description('Text used by the screen readers to describe what the progress bar represents. Make sure to add the threshold to the description if needed.'),
  'aria-label': _stencilReactDesc.PropTypes.string.description("Sets 'aria-label' on progress indicator."),
  'aria-live': _stencilReactDesc.PropTypes.oneOf(['polite', 'assertive', 'off']).description("Sets 'aria-live' on progress indicator."),
  id: _stencilReactDesc.PropTypes.string.description("Sets the 'id' attribute in the DOM for the progress bar."),
  'aria-labelledby': _stencilReactDesc.PropTypes.string.description('The id of a DOM element containing an accessible name for the progress bar. If using with threshold, ensure the label includes threshold information.'),
  'aria-describedby': _stencilReactDesc.PropTypes.string.description('The id of a DOM element containing an accessible description for the progress bar.'),
  dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes."),
  shouldShowProgressSummary: _stencilReactDesc.PropTypes.bool.description('Determines if a visible label containing the progress and progress summary should be shown.'),
  isProgressAnnounceable: _stencilReactDesc.PropTypes.func.description('Determines whether to announce a progress update or not. Must be used in conjunction with an appropriate aria-live value.')
};
var _default = ProgressBarWithDocs;
exports.default = _default;